import {useEffect, useState} from 'react';

// The app opens behind a splash that stays at least this long, so the first
// screen (and, on a memorial sticker, the switch to the memorial theme)
// happens under it instead of flashing in. Screens that are still loading
// afterwards show their own loader, which looks the same.
export const BOOT_SPLASH_MS = 2000;

export function useBootSplash(): boolean {
    const [visible, setVisible] = useState(true);
    useEffect(() => {
        const timer = setTimeout(() => setVisible(false), BOOT_SPLASH_MS);
        return () => clearTimeout(timer);
    }, []);
    return visible;
}
